// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-K1":"K1_vanlife-roadtrips-K1__NjjyK"};